/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const ARROW_LEFT_PATH = 'M11.5605 5.78033H1.06055M6.31055 11.0303L1.06055 5.78033L6.31055 0.530334';

const iconPropTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Arrow-left (12×12). Color via `color` / `stroke`, or CSS on `.ds-icon`.
 * Pass `aria-label` when used without adjacent text.
 */
const ArrowLeftIcon = ({
  size = 12,
  color,
  stroke = 'currentColor',
  strokeWidth = 1.5,
  className = '',
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    style={color ? { color, ...style } : style}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d={ARROW_LEFT_PATH}
      stroke={color || stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowLeftIcon.propTypes = iconPropTypes;

export default ArrowLeftIcon;
